import { Button } from 'antd';
import ConteudoMinistradoForm
  from '../../../create/step-1/components/conteudo-ministrado-form/conteudo-ministrado-form.component';
import '../../lancamento-aula-edit.styles.scss';
import useConteudoMinistradoWrapper
  from './use-conteudo-ministrado-wrapper.hook';
import { useTranslation } from 'react-i18next';

export default function ConteudoMinistradoWrapper() {
  const {
    formObject,
    toggleFormDisabled
  } = useConteudoMinistradoWrapper();

  const { t } = useTranslation('gestao_de_aulas');

  return (
    <div className={'lancamento-aula-edit-wrapper'}>
      <div className={'lancamento-aula-edit-wrapper__title-button'}>
        <h2>{t('gestao_de_aulas:contentTaught')}</h2>
        <Button className={'button-second'} onClick={toggleFormDisabled}>
          {t('gestao_de_aulas:edit')}
        </Button>
      </div>

      <ConteudoMinistradoForm {...formObject} />
    </div>
  );
}
